import { useEventListener } from './useEventListener';

export const useOnTabFocus = (callback) => {
  useEventListener({ target: window, eventName: 'focus', callback });
};
